import { ActivityFeedItem } from './ActivityFeedItem';
import type { ActivityEvent } from '@/lib/dashboard/useDashboardAnalytics';

export function ActivityFeed({ events }: { events: ActivityEvent[] }) {
  return (
    <div className="glass-card overflow-hidden">
      <div className="flex items-center justify-between px-5 pt-5 pb-2">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
          Recent activity
        </p>
        <span className="text-[11px] text-muted-foreground">Last 7 days</span>
      </div>

      <div className="max-h-[420px] overflow-y-auto">
        {events.map((event, i) => (
          <div key={event.id}>
            {i > 0 && <div className="mx-4 border-t border-white/5" />}
            <ActivityFeedItem event={event} />
          </div>
        ))}
      </div>
    </div>
  );
}
